import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { Vervolgstap } from '@common/customControls/bariatrics';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export const bariPostCaroInactivityReportVervolgstappen = [
    Vervolgstap.geen_actie_nodig,
    Vervolgstap.vragenlijsten_opnieuw_beschikbaar_maken,
    Vervolgstap.lifestylecoach_inschakelen,
    Vervolgstap.secretariaatsmedewerker_inschakelen,
] as const;

export type BariPostCaroInactivityReportVervolgstap = (typeof bariPostCaroInactivityReportVervolgstappen)[number];

export type BariPostCaroInactivityReportData = {
    verslag: string | null;
    vervolgstap: BariPostCaroInactivityReportVervolgstap | null;
};

const bariPostCaroInactivityReportFinal: TypedSchema<BariPostCaroInactivityReportData> = {
    verslag: getTextAreaStringSchema(),
    vervolgstap: Koi.koi().valid(...bariPostCaroInactivityReportVervolgstappen),
};

const bariPostCaroInactivityReportDraft = addAllowNull(bariPostCaroInactivityReportFinal);

export const bariPostCaroInactivityReportDraftSchema = Koi.object(bariPostCaroInactivityReportDraft);
export const bariPostCaroInactivityReportFinalSchema = Koi.object(bariPostCaroInactivityReportFinal);

export type bariPostCaroInactivityReportReadKey = keyof BariPostCaroInactivityReportData | 'inactiviteit';
export type bariPostCaroInactivityReportReadLabel = 'Inactiviteit' | 'Verslag' | 'Vervolgstap';

export const bariPostCaroInactivityReportReadSchema: TypedReadSchema<
    bariPostCaroInactivityReportReadKey,
    bariPostCaroInactivityReportReadLabel
>[] = [
    {
        items: [
            {
                key: 'inactiviteit',
                label: 'Inactiviteit',
            },
            {
                key: 'verslag',
                label: 'Verslag',
            },
            {
                key: 'vervolgstap',
                label: 'Vervolgstap',
            },
        ],
    },
];
